/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import RoleDto from './RoleDto';

/**
 * The SearchingQueryResponseModelRoleDto model module.
 * @module model/SearchingQueryResponseModelRoleDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelRoleDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelRoleDto</code>.
     * @alias module:model/SearchingQueryResponseModelRoleDto
     */
    constructor() { 
        
        SearchingQueryResponseModelRoleDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelRoleDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelRoleDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelRoleDto} The populated <code>SearchingQueryResponseModelRoleDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelRoleDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [RoleDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelRoleDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/RoleDto>} result
 */
SearchingQueryResponseModelRoleDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelRoleDto;

